export default function IDot({ width = 8, height = 8, color = "#DEDFDE", ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 8 8" fill="none">
            <g clipPath="url(#clip0_996_18668)">
                <path fillRule="evenodd" clipRule="evenodd" d="M0.75 4C0.75 2.20507 2.20507 0.75 4 0.75C5.79493 0.75 7.25 2.20507 7.25 4C7.25 5.79493 5.79493 7.25 4 7.25C2.20507 7.25 0.75 5.79493 0.75 4ZM4 1.25C2.48122 1.25 1.25 2.48122 1.25 4C1.25 5.51878 2.48122 6.75 4 6.75C5.51878 6.75 6.75 5.51878 6.75 4C6.75 2.48122 5.51878 1.25 4 1.25Z" fill={color} />
                <path d="M1 4C1 2.34315 2.34315 1 4 1C5.65685 1 7 2.34315 7 4C7 5.65685 5.65685 7 4 7C2.34315 7 1 5.65685 1 4Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_996_18668">
                    <rect width="8" height="8" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}